// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y){
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_same-value.js
// module id = 193
// module chunks = 2 3 4 5 6 7 8 9 10 11 12